/*
 * RestingBelly header menu refinement.
 * Dawn keeps ownership of opening, focus and nested-menu behavior; this helper
 * only gives desktop dropdowns and mega menus a short close transition.
 */

(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const finishClose = (details, summary, shouldRestoreFocus) => {
    details.removeAttribute('open');
    details.classList.remove('rb-menu-closing');
    summary.setAttribute('aria-expanded', 'false');
    if (shouldRestoreFocus) summary.focus();
  };

  const closeMenu = (details, summary, content, shouldRestoreFocus = false) => {
    if (!details.open || details.classList.contains('rb-menu-closing')) return;

    if (reduceMotion.matches || typeof content.animate !== 'function') {
      finishClose(details, summary, shouldRestoreFocus);
      return;
    }

    details.classList.add('rb-menu-closing');
    summary.setAttribute('aria-expanded', 'false');

    const isMegaMenu = content.classList.contains('mega-menu__content');
    const openTransform = isMegaMenu ? 'translateY(0) scale(1)' : 'translate(-50%, 0) scale(1)';
    const closedTransform = isMegaMenu
      ? 'translateY(-0.5rem) scale(0.995)'
      : 'translate(-50%, -0.5rem) scale(0.99)';

    const animation = content.animate(
      [
        { opacity: 1, transform: openTransform },
        { opacity: 0, transform: closedTransform },
      ],
      { duration: 140, easing: 'ease-out', fill: 'forwards' }
    );

    let completed = false;
    const complete = () => {
      if (completed) return;
      completed = true;
      finishClose(details, summary, shouldRestoreFocus);
      animation.cancel();
    };

    animation.finished.then(complete, complete);
  };

  document.querySelectorAll('header-menu > details').forEach((details) => {
    if (details.dataset.rbMenuEnhanced === 'true') return;

    const summary = details.querySelector(':scope > summary');
    const content = summary?.nextElementSibling;
    const isSupportedMenu =
      content?.classList.contains('header__submenu') || content?.classList.contains('mega-menu__content');
    if (!summary || !content || !isSupportedMenu) return;

    details.dataset.rbMenuEnhanced = 'true';
    let wasOpenBeforeActivation = false;

    summary.addEventListener(
      'pointerdown',
      () => {
        wasOpenBeforeActivation = details.open;
      },
      true
    );

    summary.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Enter' || event.key === ' ') wasOpenBeforeActivation = details.open;
      },
      true
    );

    summary.addEventListener(
      'click',
      (event) => {
        if (!wasOpenBeforeActivation) return;
        wasOpenBeforeActivation = false;
        event.preventDefault();
        event.stopImmediatePropagation();
        closeMenu(details, summary, content);
      },
      true
    );

    details.addEventListener(
      'keyup',
      (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        if (event.target.closest('details[open]') !== details) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        closeMenu(details, summary, content, true);
      },
      true
    );
  });
})();
